import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import { Gender } from "types";

import RadioGroup from "./radio-group";

//TODO: fetch from options when available in credit request forms
const DEFAULT_GENDER_OPTIONS: Gender[] = ["MALE", "FEMALE", "OTHER"];

interface GenderRadioGroupProps<T> {
  fieldName: string;
  form: UseFormReturnType<T>;
  genderOptions?: Gender[];
  label?: string;
  disabled?: boolean;
  required?: boolean;
}

const GenderRadioGroup = <T,>(props: GenderRadioGroupProps<T>) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    genderOptions = DEFAULT_GENDER_OPTIONS,
    label = t("user.gender.label"),
    disabled,
    required,
  } = props;

  const options = genderOptions.map((option) => ({
    value: option,
    label: t(`user.gender.options.${option}`),
  }));

  return (
    <RadioGroup
      fieldName={fieldName}
      label={label}
      options={options}
      form={form}
      disabled={disabled}
      required={required}
    />
  );
};

export default GenderRadioGroup;
